module.exports = __webpack_public_path__ + "img/twobirds.84499dae.png";